// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * list of modules
 * @export
 * @enum {string}
 */
export var TenantModuleEnum;
(function (TenantModuleEnum) {
    TenantModuleEnum["PE"] = "PE";
    TenantModuleEnum["INFRA"] = "INFRA";
    TenantModuleEnum["RE"] = "RE";
    TenantModuleEnum["PD"] = "PD";
    TenantModuleEnum["CFF"] = "CFF";
    TenantModuleEnum["RISK"] = "RISK";
    TenantModuleEnum["ESG"] = "ESG";
    TenantModuleEnum["COMPARE"] = "COMPARE";
    TenantModuleEnum["RISKBENCHMARKING"] = "RISKBENCHMARKING";
})(TenantModuleEnum || (TenantModuleEnum = {}));
export function TenantModuleEnumFromJSON(json) {
    return json;
}
export function TenantModuleEnumToJSON(value) {
    return value;
}
